import { createContext, useContext } from 'react';
import { useMenuData } from '../../../primitives/menu';
import { Theme as DonutThemeElement, useThemeFillStyles } from '../../../primitives/theme';
import { useChartColors } from '../../../primitives/theme/hooks/useChartColors';
import { DonutScalesElement } from '../elements/scale';
import { jsx as _jsx } from "react/jsx-runtime";
const DataContext = /*#__PURE__*/createContext({});
export function DonutDataProvider(_ref) {
  let {
    children,
    ...props
  } = _ref;
  const {
    showPatterns
  } = useMenuData();
  const fillStyles = useChartColors();
  return /*#__PURE__*/_jsx(DonutThemeElement, {
    fillStyles: fillStyles,
    enableDefaultPatterns: showPatterns,
    useThemeFillStyles: useThemeFillStyles,
    children: /*#__PURE__*/_jsx(DonutScalesElement, {
      ...props,
      sort: "asc",
      children: scales => /*#__PURE__*/_jsx(DataContext.Provider, {
        value: {
          ...props,
          ...scales
        },
        children: children
      })
    })
  });
}
export function useDonutData() {
  return useContext(DataContext);
}